module.exports = __webpack_public_path__ + "img/f-thermometer-img6-2.4a5d1455.png";